/**
 * Renders and wires the slide-down inline Search controller.
 */
export function openSearchBar(wrapper, textarea) {
  closeSearchBar(wrapper);

  wrapper.classList.add('search-active');
  const bar = document.createElement('div');
  bar.className = 'editor-search-bar';

  const group = document.createElement('div');
  group.className = 'search-input-group';

  const input = document.createElement('input');
  input.type = 'text';
  input.className = 'search-input';
  input.placeholder = 'Search...';

  const prevBtn = document.createElement('button');
  prevBtn.type = 'button';
  prevBtn.className = 'search-btn search-prev-btn';
  prevBtn.title = 'Find Previous';
  prevBtn.textContent = '▲';

  const nextBtn = document.createElement('button');
  nextBtn.type = 'button';
  nextBtn.className = 'search-btn search-next-btn';
  nextBtn.title = 'Find Next';
  nextBtn.textContent = '▼';

  const badge = document.createElement('span');
  badge.className = 'search-badge';
  badge.textContent = '0/0';

  group.appendChild(input);
  group.appendChild(prevBtn);
  group.appendChild(nextBtn);
  group.appendChild(badge);

  const closeBtn = document.createElement('button');
  closeBtn.type = 'button';
  closeBtn.className = 'search-close-btn';
  closeBtn.title = 'Close Search';
  closeBtn.textContent = '✕';

  bar.appendChild(group);
  bar.appendChild(closeBtn);
  wrapper.appendChild(bar);

  let matches = [];
  let currentIdx = -1;

  function highlightMatch(queryLen) {
    if (currentIdx === -1 || matches.length === 0) return;
    const start = matches[currentIdx];
    textarea.focus();
    textarea.setSelectionRange(start, start + queryLen);

    // Centering alignment calculation
    const textBefore = textarea.value.substring(0, start);
    const lines = textBefore.split('\n').length;
    const textareaHeight = textarea.scrollHeight;
    const totalLines = textarea.value.split('\n').length;
    textarea.scrollTop = (lines / totalLines) * textareaHeight - (textarea.clientHeight / 2);
  }

  function performSearch() {
    const query = input.value;
    matches = [];
    currentIdx = -1;
    if (!query) {
      badge.textContent = '0/0';
      return;
    }

    const text = textarea.value.toLowerCase();
    const queryLower = query.toLowerCase();
    let idx = text.indexOf(queryLower);
    while (idx !== -1) {
      matches.push(idx);
      idx = text.indexOf(queryLower, idx + queryLower.length);
    }

    if (matches.length > 0) {
      currentIdx = 0;
      badge.textContent = `1/${matches.length}`;
      highlightMatch(query.length);
    } else {
      badge.textContent = '0/0';
    }
  }

  input.addEventListener('input', performSearch);

  nextBtn.addEventListener('click', () => {
    if (matches.length === 0) return;
    currentIdx = (currentIdx + 1) % matches.length;
    badge.textContent = `${currentIdx + 1}/${matches.length}`;
    highlightMatch(input.value.length);
  });

  prevBtn.addEventListener('click', () => {
    if (matches.length === 0) return;
    currentIdx = (currentIdx - 1 + matches.length) % matches.length;
    badge.textContent = `${currentIdx + 1}/${matches.length}`;
    highlightMatch(input.value.length);
  });

  closeBtn.addEventListener('click', () => {
    closeSearchBar(wrapper);
  });

  input.addEventListener('keydown', (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      nextBtn.click();
    } else if (e.key === 'Escape') {
      closeSearchBar(wrapper);
    }
  });

  input.focus();
}

export function closeSearchBar(wrapper) {
  if (!wrapper) return;
  wrapper.classList.remove('search-active');
  const bar = wrapper.querySelector('.editor-search-bar');
  if (bar) {
    bar.remove();
  }
}

export function closeAllSearchBars() {
  document.querySelectorAll('.editor-wrapper.search-active').forEach((wrapper) => {
    closeSearchBar(wrapper);
  });
}
